
import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';
/*
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';
*/
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-salesbysupervcategorychief',
  templateUrl: './salesbysupervcategorychief.component.html',
  styleUrls: ['./salesbysupervcategorychief.component.css']
})
export class SalesbysupervcategorychiefComponent extends BaseCrudComponent {

  	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    cats:any;
    catcount:any;
    innercats:any;
    total_cats:any;
    laboralDays:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportSalesPerClientPerCategoryJefe/Post';
        this.header = {};
        this.theaders = ['SUPERVISOR', 'VTA REAL', 'OBJ. VTA', '% CUMP', '', '% MARGEN'];
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.total_cats = [];
        this.cats = [];
        this.catcount = [];
        this.innercats = [];
        this.laboralDays = [];
    }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        /*this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });*/
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.total_cats = [];
        this.cats = [];
        this.catcount = [];
        this.innercats = [];
        this.laboralDays = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            //Zone: null,
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.header = rs.header;
                this.rows = rs.detail.detail;
                this.totals = rs.totals;
                this.total_cats = rs.totalsByCategories;
                this.laboralDays = rs.laboralDays;
                this.cats = this.getDynamicHeaders(this.rows);
                this.catcount = Array(rs.detail.groupsNumber * 4).fill(0).map((x,i)=>i);

                this.rows.forEach(r => {
                	r.semaforo_sales = this.getColor(r.accomplishmentPerc);
                });
                
                this.cats.forEach(c => {
                	this.innercats.push('VTAS');
                	this.innercats.push('OBJ. VTA');
                	this.innercats.push('% CUMP');
                	this.innercats.push('% MARGEN');
                });
            }
        });
    }

    getColor(par:any){
        var r:any;
        r = {};
        par = par.replace(' %', '');
        par = parseFloat(par.replace(/,/g, ''));

        if(par <= 80){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if(par > 95){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getDynamicHeaders(rows:any){
    	var resp = [];

    	if( Array.isArray(rows) && (rows.length > 0) ){
    		rows.forEach(x => {
    			x.categories.forEach(c => {
    				let cat = c.categoryName;
    				if( resp.indexOf(cat) < 0 ){
    					resp.push(cat);
    				}
    			});
    		});
    	}

    	return resp;
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'vta_superv_cat_'+this.curr_date).subscribe(() => {
          // save started
        });
    }

}
